import { userSettingsModel } from 'APP/model/model';
import Entities from 'STORE';

export async function getSessionsInfo(): Promise<void> {
  Entities.sessionsStore.setMyCurrentSession();

  if (Entities.sessionsStore.sessions.length) {
    Entities.sessionsStore.reset();
  }

  const response = await userSettingsModel.getDevicesInfo();

  Entities.sessionsStore.setCurrentSession(response?.currentDevice.device);

  Entities.sessionsStore.setSessions(response?.devices);

  // Entities.sessionsStore.setSessionTtl(response.sessionsTtl);
}
